import React, { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import { RiFilter2Fill } from "react-icons/ri";
import { FaChevronLeft } from "react-icons/fa";
import { useSelector, shallowEqual } from 'react-redux'
import { AiFillDelete } from "react-icons/ai";
import FilterToggle from "../FilterToggle";
import SelectSearch from "../metronicLayout/components/filterSelect/SelectSearch";
import Select from 'react-select';
import list from '../occupationsList'
import { GetCoachesByOrgId, GetSavedFilters, DeleteFilter, GetOccupationList } from '../api'
import AsyncSelect from 'react-select/async';
import { useParams } from 'react-router-dom';
import { useLocation, useHistory } from 'react-router-dom';
import { GetUserDetails } from "./api";
import moment from "moment";

const Filter = ({ show, setShow, savedFilter, handleFilter, type, currentFilter }, ref) => {

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const [stages, setStages] = useState({
    resume: {
      all: false,
      needsResumeBuilt: false,
      needsResumeReviewed: false,
      resumeInProgress: false,
      resumeCompleted: false,
      clearStatus: false,
    },
    coverLetter: {
      all: false,
      needsCoverLetterBuilt: false,
      needsCoverLetterReviewed: false,
      coverLetterInProgress: false,
      coverLetterCompleted: false,
      clearStatus: false,
    },
    references: {
      all: false,
      needsReferencesBuilt: false,
      needsReferencesReviewed: false,
      referencesInProgress: false,
      referencesCompleted: false,
      clearStatus: false,
    },
    linkedIn: {
      all: false,
      needsLinkedInAccountCreated: false,
      needsProfileFilledOut: false,
      needsLinkedInProfileReviewed: false,
      linkedInInProgress: false,
      linkedInCompleted: false,
      clearStatus: false,
    },
    jobApplications: {
      all: false,
      needsToApplyForJobs: false,
      applyingForJobs: false,
      clearStatus: false,
    },
    registeredJobBoards: {
      all: false,
      zipRecruiter: false,
      indeed: false,
      Monster: false,
      careerBuilder: false,
    },
  })
  const [activites, setActivites] = useState([]);
  const [occupationInterest, setOccupationInterest] = useState([]);
  const [coachList, setCoachList] = useState([]);
  const [OccupationList, setOccupationList] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('')
  const [saveFilter, setSaveFilter] = useState({
    save: false,
    name: ''
  })

  const [savedList, setSavedList] = useState([]);
  const [pending, setPending] = useState(false);

  const [inputCheck1, setInputCheck1] = useState(false);
  const [inputCheck2, setInputCheck2] = useState(false);

  const [userDetails, setUserDetails] = useState([]);

  console.log(show, "show");

  useImperativeHandle(ref, () => ({
    handleClearFilter(){
      setFromDate('');
      setToDate('');
      setOccupationInterest([]);
      setActivites([]);
      setStages({
        resume: {
          all: false,
          needsResumeBuilt: false,
          needsResumeReviewed: false,
          resumeInProgress: false,
          resumeCompleted: false,
          clearStatus: false,
        },
        coverLetter: {
          all: false,
          needsCoverLetterBuilt: false,
          needsCoverLetterReviewed: false,
          coverLetterInProgress: false,
          coverLetterCompleted: false,
          clearStatus: false,
        },
        references: {
          all: false,
          needsReferencesBuilt: false,
          needsReferencesReviewed: false,
          referencesInProgress: false,
          referencesCompleted: false,
          clearStatus: false,
        },
        linkedIn: {
          all: false,
          needsLinkedInAccountCreated: false,
          needsProfileFilledOut: false,
          needsLinkedInProfileReviewed: false,
          linkedInInProgress: false,
          linkedInCompleted: false,
          clearStatus: false,
        },
        jobApplications: {
          all: false,
          needsToApplyForJobs: false,
          applyingForJobs: false,
          clearStatus: false,
        },
        registeredJobBoards: {
          all: false,
          zipRecruiter: false,
          indeed: false,
          Monster: false,
          careerBuilder: false,
        },
      })
      setSaveFilter({
        name: '',
        save: false
      })
      setCoachList([])
      setUserDetails([])
    },
    handleClearFromDate(){
      setFromDate('')
    },
    handleClearToDate(){
      setToDate('')
    },
    handleClearOccupationInterest(value){
      setOccupationInterest(value)
    },
    handleClearActivities(value){
      setActivites(value)
    },
    handleClearStage(value){
      switch(value){
        case 'resume':
          setStages((pre)=>({
            ...pre,
            resume: {
              all: false,
              needsResumeBuilt: false,
              needsResumeReviewed: false,
              resumeInProgress: false,
              resumeCompleted: false,
              clearStatus: false,
            }
          }))
          break;
        case 'coverLetter':
          setStages((pre)=>({
            ...pre,
            coverLetter: {
              all: false,
              needsCoverLetterBuilt: false,
              needsCoverLetterReviewed: false,
              coverLetterInProgress: false,
              coverLetterCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'references':
          setStages((pre)=>({
            ...pre,
            references: {
              all: false,
              needsReferencesBuilt: false,
              needsReferencesReviewed: false,
              referencesInProgress: false,
              referencesCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'linkedIn':
          setStages((pre)=>({
            ...pre,
            linkedIn: {
              all: false,
              needsLinkedInAccountCreated: false,
              needsProfileFilledOut: false,
              needsLinkedInProfileReviewed: false,
              linkedInInProgress: false,
              linkedInCompleted: false,
              clearStatus: false,
            },
          }))
          break;
        case 'jobApplications':
          setStages((pre)=>({
            ...pre,
            jobApplications: {
              all: false,
              needsToApplyForJobs: false,
              applyingForJobs: false,
              clearStatus: false,
            },
          }))
          break;
        case 'registeredJobBoards':
          setStages((pre)=>({
            ...pre,
            registeredJobBoards: {
              all: false,
              zipRecruiter: false,
              indeed: false,
              Monster: false,
              careerBuilder: false,
            },
          }))
          break;
        default: 
          break;
      }
    },
    handleApplyFilter(value){
      alert('allpp')
      handleApply(value)
    },
    handleClearCoaches(coaches){
      setCoachList(coaches)
    },
    handleClearUserDetails(value = []){
      setUserDetails(value)
    }
  }));

  const history = useHistory();

  useEffect(()=>{
    let data = list.map(e=>{
      return {
        value: e,
        label: e
      }
    })
    setOccupationList(data);
  },[])

  useEffect(()=>{
    if(currentFilter){
      handleSetSavedFilter({query: currentFilter});
    }
  }, [currentFilter])

  const handleApply = async (query = null) => {
    let tempStages = {};
    for(let stage in stages){
      for(let key in stages[stage]){
        if(key != 'all' && stages[stage][key]){
          console.log([stage][key]);
          tempStages = {
            ...tempStages,
            [stage]: {
              ...tempStages[stage],
              [key]: stages[stage][key]
            }
          }
          // [tempStages[stage][key]] = stages[stage][key]
        }
      }
    }
    let tempActivities = activites.filter(e=>e!='all');

    let filter = {
      stages: tempStages,
      activities: tempActivities,
      occupationInterest: occupationInterest.map(e=>e.value),
      from: fromDate,
      to: toDate,
      coaches: coachList,
      userDetails: userDetails
    }
    if(saveFilter.save && saveFilter.name == ''){
      alert('Please enter filter name before save');
      return ;
    }
    if(saveFilter.save && saveFilter.name != ''){
      filter.save = true;
      filter.name = saveFilter.name
    }

    console.log(query);
    if(!query){
      await handleFilter(filter)
      // alert('yes')
      if(saveFilter.save && saveFilter.name != ''){
        handleGetSavedFilter();
        setSaveFilter({
          save: false,
          name: ''
        })
      }
    }else{
      handleFilter(query)
    }
    console.log(filter);
  }
  const handleGetSavedFilter = async ()=> {
    setPending(true)
    try{
      let res = await GetSavedFilters(user.id, type);
      setSavedList(res.filters)
    }catch(ex){
      console.log(ex);
    }finally{
      setPending(false)
    }
  }
  const handleGetCoaches = async (inputValue)=>{
    let res = await GetCoachesByOrgId(user.organization, inputValue);
    return res.coaches.map(e=>{
      return {
        label: `${e.firstName} ${e.lastName}`,
        value: e._id
      }
    })
  }
  const handleGetOccupationInterest = async (inputValue)=>{
    let res = await GetOccupationList(inputValue);
    return res.list.map(e=>{
      return {
        label: e.name,
        value:e.name
      }
    })
  }

  // useEffect(()=>{
  //   handleGetSavedFilter();
  // }, [])
  const handleSetSavedFilter = (filter) => {
    let Query = {};
    if(filter.query.from){
      setFromDate(filter.query.from)
      Query.from = filter.query.from
    }
    if(filter.query.to){
      setToDate(filter.query.to)
      Query.to = filter.query.to
    }
    if(filter.query.activities){
      setActivites(filter.query.activities)
      Query.activities = filter.query.activities
    }
    if(filter.query.occupationInterest){
      setOccupationInterest(filter.query.occupationInterest.map(e=>({
        label: e,
        value: e
      })))
      Query.occupationInterest = filter.query.occupationInterest
    }
    if(filter.query.coaches){
      setCoachList(filter.query.coaches)
      Query.coaches = filter.query.coaches
    }
    if(filter.query.stages){
      let temp = stages;
      for(let stage in filter.query.stages){
        for(let key in filter.query.stages[stage]){
          temp = {
            ...temp,
            [stage]: {
              ...temp[stage],
              [key]: filter.query.stages[stage][key]
            }
          }
        }
      }
      let tempStages = {};
      for(let stage in temp){
        for(let key in temp[stage]){
          if(key != 'all' && temp[stage][key]){
            console.log([stage][key]);
            tempStages = {
              ...tempStages,
              [stage]: {
                ...tempStages[stage],
                [key]: temp[stage][key]
              }
            }
            // [tempStages[stage][key]] = stages[stage][key]
          }
        }
      }
      setStages(temp)
      Query.stages = tempStages
    }

    handleApply(Query);
    console.log(Query);
    savedFilter(filter.name)
  }
  const handleDeleteFilter = async (filter) => {
    try{
      let res = await DeleteFilter(filter._id);
      handleGetSavedFilter();
    }catch(ex){
      console.log(ex);
    }
  }
  useEffect(()=>{ 
    console.log(user.organization, 'yes tes tess');
  }, [user])

  const handleGetUserDetails = async (inputValue) => {
      let res = await GetUserDetails(user.organization, inputValue);
      let data = res;

      const groupedOptions = [
          {
              label: "Source",
              options: data.sources.map((item) => ({ label: item, value: item, type: "source" })),
          },
          {
              label: "Platform",
              options: data.platforms.map((item) => ({ label: item, value: item, type: "platform" })),
          },
          {
              label: "Birth Date",
              options: data.birthDates.map((item) => ({ label: moment(item).format("YYYY-MM-DD"), value: item, type: "birthDate" })),
          },
          {
              label: "First Name",
              options: data.firstNames.map((item) => ({ label: item, value: item, type: "firstName" })),
          },
          {
              label: "Last Name",
              options: data.lastNames.map((item) => ({ label: item, value: item, type: "lastName" })),
          },
          {
              label: "Gender",
              options: data.genders.map((item) => ({ label: item, value: item, type: "gender" })),
          }
      ];

      return groupedOptions;
  };


  const location = useLocation();
  const isCoachPage = location.pathname === '/choches'

  return (
    <div className={`container-fluid position`} style={{position:"fixed" , width:"21.7rem"}}>
    {/* <div className={`${show ? "d-none" : ""} container-fluid position`}> */}
      <div className="container pt-5  m-0 p-0">
        <div className="d-flex align-items-center    justify-content-between py-3">
          <div className="  d-flex align-items-center">
            <RiFilter2Fill className="font2" />
            <p className="  text-black font-weight-bold font3 mt-4 ml-2">
              Filters
            </p>
          </div>

          <div
            className="bg-primary  primary d-flex justify-content-center align-items-center"
            onClick={() => {history.push('/reportoverview/coaches')}}
          >
            <FaChevronLeft className="text-white font-bold icon" />
          </div>
        </div>

        {/* <FilterToggle title="My Saved Search" className="" top="mt-5">
        { !pending && savedList.length == 0 && <span className="border-none pl-3 bgc py-2 text-dark d-block">No Saved Filters</span> }
          { pending && <div className="w-100 d-flex align-items-center justify-content-between mb-2" >
                  <div class="spinner-border text-danger mx-auto" role="status"></div>
              </div>  }
          { !pending && savedList.map((filter, i)=>{
            return <div className="d-flex justify-content-between bgc">
                <span key={i} style={{width: '90%'}} onClick={()=>{handleSetSavedFilter(filter)}} className="border-none pl-3  py-2 text-dark d-block">
                  { filter.name }
                </span>
                <button onClick={()=>{handleDeleteFilter(filter)}} style={{width: '10%'}} className="bg-transparent border-0">
                  <AiFillDelete className="icon"/>
              </button>
            </div>
          }) }
        </FilterToggle> */}

        <FilterToggle title="Choose Profile Details" className="" top="mt-5">
          <div>
          <AsyncSelect
            isClearable
            isMulti
            onChange={(value)=>{
              if(!value){
                setUserDetails([])
              }else{
                setUserDetails(value)
              }
              // console.log(value);
            }}
            value={userDetails}
            cacheOptions
            defaultOptions
            loadOptions={handleGetUserDetails}
            placeholder="Search"
          />
          </div>

        </FilterToggle>

        <FilterToggle title="Choose Coaches" className="" top="mt-5">
          <div className="">
            <AsyncSelect 
              isClearable
              isMulti
              value={coachList}
              onChange={(value)=>{
                if(!value){
                  setCoachList([])
                }else{
                  setCoachList(value)
                }
              }}
              cacheOptions
              defaultOptions
              loadOptions={handleGetCoaches}
              placeholder={'Search by Name or Email'}
            />
          </div>
        </FilterToggle>


        <FilterToggle title="Choose Activity" className="" top="mt-5">

<div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc' onClick={
  ()=>{
    if(!activites.includes('all')){
      setActivites(['all', 'Text', 'Call', 'Email', 'Meeting', 'Note', 'Other'])
    }else{
      setActivites([])
    }
  }
}>
  <label className=" border-0 text-dark d-block text-dark pt-2">All</label>
  <input id='one1' checked={activites.includes('all')} onChange={()=>{
    if(!activites.includes('all')){
      setActivites(['all', 'Text', 'Call', 'Email', 'Meeting', 'Note', 'Other'])
    }else{
      setActivites([])
    }
  }} type="checkbox" className='' />
</div>

<div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc' 
  onClick={
    ()=>{
      if(activites.includes('Call')){
        setActivites(activites.filter(e=>e!='Call'))
      }else{
        setActivites([...activites, 'Call'])
      }
    }
  }
>
  <label className=" border-0 text-dark  d-block text-dark pt-2">Call</label>
  <input id='two1' checked={activites.includes('Call')} onChange={()=>{
    if(activites.includes('Call')){
      setActivites(activites.filter(e=>e!='Call'))
    }else{
      setActivites([...activites, 'Call'])
    }
  }} type="checkbox" />
</div>

<div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
  onClick={()=>{
    if(activites.includes('Email')){
      setActivites(activites.filter(e=>e!='Email'))
    }else{
      setActivites([...activites, 'Email'])
    }
  }}
>
  <label className=" border-0 text-dark d-block text-dark pt-2" >Email</label>
  <input id='three1' checked={activites.includes('Email')} onChange={()=>{
    if(activites.includes('Email')){
      setActivites(activites.filter(e=>e!='Email'))
    }else{
      setActivites([...activites, 'Email'])
    }
  }} type="checkbox" />
</div>

<div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
  onClick={
    ()=>{
      if(activites.includes('Text')){
        setActivites(activites.filter(e=>e!='Text'))
      }else{
        setActivites([...activites, 'Text'])
      }
    }
  }
>
  <label className=" border-0 text-dark  d-block text-dark pt-2">Text</label>
  <input id='four1' checked={activites.includes('Text')} onChange={()=>{
    if(activites.includes('Text')){
      setActivites(activites.filter(e=>e!='Text'))
    }else{
      setActivites([...activites, 'Text'])
    }
  }} type="checkbox" />
</div>

<div className='d-flex justify-content-between px-3 align-items-center py-0 bgc' 
  onClick={
    ()=>{
      if(activites.includes('Meeting')){
        setActivites(activites.filter(e=>e!='Meeting'))
      }else{
        setActivites([...activites, 'Meeting'])
      }
    }
  }
>
  <label className=" border-0 text-dark  d-block text-dark pt-2">Meeting</label>
  <input id='five1' checked={activites.includes('Meeting')} onChange={()=>{
    if(activites.includes('Meeting')){
      setActivites(activites.filter(e=>e!='Meeting'))
    }else{
      setActivites([...activites, 'Meeting'])
    }
  }} type="checkbox" />
</div>

<div className='d-flex justify-content-between px-3 align-items-center py-0 bgc'
 onClick={
  ()=>{
    if(activites.includes('Note')){
      setActivites(activites.filter(e=>e!='Note'))
    }else{
      setActivites([...activites, 'Note'])
    }
  }
 }
>
  <label className=" border-0 text-dark  d-block text-dark pt-2">Note</label>
  <input id='six1' checked={activites.includes('Note')} onChange={()=>{
    if(activites.includes('Note')){
      setActivites(activites.filter(e=>e!='Note'))
    }else{
      setActivites([...activites, 'Note'])
    }
  }} type="checkbox" />
</div>

<div className='d-flex  justify-content-between px-3 align-items-center py-0 bgc'
  onClick={()=>{
    if(activites.includes('Other')){
      setActivites(activites.filter(e=>e!='Other'))
    }else{
      setActivites([...activites, 'Other'])
    }
  }}
>
  <label className=" border-0 text-dark  d-block text-dark pt-2">Other</label>
  <input id='seven1' checked={activites.includes('Other')} onChange={()=>{
    if(activites.includes('Other')){
      setActivites(activites.filter(e=>e!='Other'))
    }else{
      setActivites([...activites, 'Other'])
    }
  }} type="checkbox" />
</div>

</FilterToggle>

        {/* <FilterToggle title="Choose Time Period" className="" top="mt-5">

          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">1 Week</span>
          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">3 Weeks</span>
          <span onClick={
            ()=>{
              let from = new Date(Date.now() - 42 * 24 * 60 * 60 * 1000).toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');;

              setFromDate(from);
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">6 Weeks</span>
          <span onClick={
            ()=>{
              let from = new Date();
              from.setFullYear(from.getFullYear()-1)
              let to = new Date().toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-');

              setFromDate(from.toLocaleDateString('en-CA', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              }).replace(/\//g, '-'));
              setToDate(to)
            }
          } className="border-none pl-3 bgc py-2 text-dark d-block">1 Year</span>

        </FilterToggle> */}

        <div className='d-flex justify-content-between my-5'>
          <input type='date' value={fromDate} onChange={(e)=>{e.persist(); setFromDate(e.target.value)}} className='py-4 fltr color1 outline-0 outline-none' style={{width:"49%"}} />
          <input type='date' value={toDate} onChange={(e)=>{e.persist(); setToDate(e.target.value)}} className='py-4 fltr color1 outline-0 outline-none' style={{width:"49%"}}/>

        </div>

        {/* <div className=' d-flex flex-column '>
          <div className='d-flex'>
        <input id="click" checked={saveFilter.save} onChange={()=>{setSaveFilter((pre)=>({...pre, save: !saveFilter.save}))}} type="checkbox"/>
        <label for="click" className='font5 ml-2 mt-2'>Save filter for future use.</label>
        </div>
        { saveFilter.save && <input type="text" value={saveFilter.name} onChange={(e)=>{ e.persist() ;setSaveFilter((pre)=>({...pre, name: e.target.value}))}} placeholder='Enter Filter Name' className='py-4 mt-2 color1 outline-none '/> }
        </div> */}

        <button onClick={()=>{handleApply()}} className='bg_c py-3 border-0 outline-0 w-100'>Apply Filters</button>
      </div>
    </div>
  );
};

export default forwardRef(Filter)
